<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog :value="displayOverrideThemeBpsDialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        {{ $t('enableOverride') }}
      </v-card-title>

      <v-card-text>
        <div class="mb-2">{{ $t('override') }}</div>
        <ul>
          <li v-for="bp in availableBusinessProcesses" :key="bp">
            {{ bp }}
          </li>
        </ul>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="onDialogClose">
          {{ $t('no') }}
        </v-btn>
        <v-btn color="primary" text @click="onDialogAccept">
          {{ $t('yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'EcsOverrideThemesBpsDialog.vue',
  data() {
    return {
      checkedBusinessProcesses: this.selectedBusinessProcesses
    };
  },
  computed: {
    ...mapGetters(['businessProcesses', 'selectedBusinessProcesses', 'displayOverrideThemeBpsDialog']),
    availableBusinessProcesses() {
      const bps = [];
      this.selectedBusinessProcesses.forEach(bp => {
        const foundBp = this.businessProcesses.find(el => el.endPoint === bp);
        if (foundBp) {
          bps.push(foundBp.name);
        }
      });
      return bps;
    }
  },
  methods: {
    ...mapActions(['setSelectedBusinessProcesses', 'toggleOverrideThemeForBpsDialog', 'updateOverrideDefaultTheme']),
    onDialogClose() {
      this.toggleOverrideThemeForBpsDialog();
    },
    onDialogAccept() {
      this.toggleOverrideThemeForBpsDialog();
      this.updateOverrideDefaultTheme({ payload: true, vuetify: this.$vuetify });
    }
  }
};
</script>

<style></style>
